<!-- <div class="topbar-layout flex flex-col ">
  <div class="columns-3 w-full">
    <div class="flex float-left order-first z-50">
      <div class="menu-icon-cointainer">
        <a class="menu-button cursor-pointer " (click)="togSide()">
          <i class="e-icons e-menu"></i>
        </a>
      </div>
      <div *ngIf="!isMobile" class="breadcrumbs-container ml-4 ">

        <app-bread-crumbs></app-bread-crumbs>
      </div>
    </div>






    <h1 class="text-xl flex flex-row justify-center content-center title">{{titolo}}</h1>

    <div *ngIf="isMobile && show" class="z-50">
      <a (click)="togSide()" class="cursor-pointer">
        <i class="e-icons e-close"></i>
      </a>
    </div>
    <div *ngIf="isMobile && !show" class="z-50">
      <a class="menu-button ">
        <i class="e-icons e-close invisible"></i>
      </a>
    </div>
    <div *ngIf="!isMobile" class="z-50">
      <a class="menu-button ">
        <i class="e-icons e-close invisible"></i>
      </a>
    </div>


  </div>

  <div *ngIf="isMobile" class="ml-4 mt-2">

    <app-bread-crumbs></app-bread-crumbs>
  </div>
</div> -->
<div *ngIf="!connectionStatus" class="sticky top-0 w-full bg-red-500 text-white text-center "
  style="z-index: 9999999999999999;">
  <p>Connessione assente</p>
</div>

<header id="header-elem" class="relative" style="max-width: 100dvw;">
<div class="w-full p-2">


  
      <div class="flex items-center justify-between w-full pt-2 " style="color:white!important">
        <button mat-icon-button (click)="togSide()">
          <mat-icon>menu</mat-icon>
        </button>
  
    
    
      <span class="spacer"></span>
    
      <h3 class="font-bold text-lg lg:text-2xl text-center text-text text-wrap w-full">{{titolo}}</h3>
    
          <span class="spacer"></span>

          <!-- <button mat-icon-button (click)="showNotifs = !showNotifs;blockScroll()" style="z-index: 1006;">
        
              <mat-icon [matBadge]="toRead > 0 ? toRead : ''" *ngIf="!showNotifs">notifications_none</mat-icon>
              <mat-icon *ngIf="showNotifs">close</mat-icon>
          
          </button> -->

          <!-- <button
            class="text-primary-600 hover:text-white hover:bg-primary-500 rounded-2xl flex justify-center items-center gap-1 {{showNotifs ? 'text-primary-600 hover:text-white hover:bg-primary-500 bg-primary-50' : ''}} "
            >
            <div class="relative w-6 h-6">
              <svg *ngIf="!showNotifs" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-6 h-6 absolute">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />
                <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
              </svg>
              <svg *ngIf="showNotifs" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-6 h-6 absolute">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M18 6l-12 12" />
                <path d="M6 6l12 12" />
              </svg>
            </div>
            <h4 class="rounded-full font-bold">{{toRead}}</h4>
          </button> -->
    
        </div>

  
    <!-- <div class="flex justify-start items-center gap-2 overflow-auto hide-scrollbar">
      <button mat-button class="text-primary-600 hover:text-white flex rounded-full justify-center items-center " (click)="back()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M9 14l-4 -4l4 -4" />
          <path d="M5 10h11a4 4 0 1 1 0 8h-1" />
        </svg>
      </button>
      
      <app-bread-crumbs></app-bread-crumbs>
    </div> -->
  
  
  </div>

  

</header>


<!-- sticky breadcrumb -->
<!-- <div class="z-50 px-4 py-1 top-0 backdrop-blur-2xl w-full sticky overflow-hidden">

  <app-bread-crumbs></app-bread-crumbs>
</div> -->



<div @fadeInOutWithBlur *ngIf="showNotifs"
  class="card-danger bg-transparent backdrop-blur-xl backdrop-brightness-50 rounded-none flex flex-col justify-start items-center min-h-screen max-h-screen w-screen  fixed top-0 left-0"
  style="z-index: 1005;will-change: filter;">





  <app-notifications-center class="w-full lg:w-2/3 pt-10"></app-notifications-center>

</div>